import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';

const CAMERA_FIT_DISTANCE_RATIO = 0.5;

export function resetView(
  objectGroup: THREE.Group,
  camera: THREE.PerspectiveCamera,
  controls: OrbitControls,
): THREE.Box3 | null {
  const box = new THREE.Box3().setFromObject(objectGroup);
  if (!box.isEmpty()) {
    fitToScene(box, camera, controls);
    return box;
  }
  return null;
}

function fitToScene(
  bbox: THREE.Box3,
  camera: THREE.PerspectiveCamera,
  controls: OrbitControls,
): void {
  const center = bbox.getCenter(new THREE.Vector3());
  const dims = bbox.getSize(new THREE.Vector3());
  const largest = Math.max(dims.x, dims.y, dims.z);

  camera.up.set(0, 0, 1);
  camera.position.copy(center).addScalar(largest * CAMERA_FIT_DISTANCE_RATIO);
  camera.lookAt(center);
  controls.target.copy(center);
  controls.update();
}
